import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const QualityPage = lazy(() => import('../pages/quality/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PartNumbersPage = lazy(() => import('../pages/part-numbers/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/quality',
    element: <QualityPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/part-numbers',
    element: <PartNumbersPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
